import { Box, Grid, Stack } from "@mui/material";
import React, { PropsWithChildren } from "react";
import { DKGridTitle } from "./DKGridTitle";

export type DKGridColumnProps = {
  width: number;
  title?: string;
};

export const DKGridColumn = (props: PropsWithChildren<DKGridColumnProps>) => {
  const { width, title, children } = props;
  return (
    <Grid item xs={width}>
      <Stack spacing={1}>
        <Box
          sx={{
            minHeight: "35px",
          }}
        >
          {title && (
            <DKGridTitle
              title={title}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"flex-end"}
              marginBottom={1}
              fontWeight={"bold"}
            />
          )}
        </Box>
        <Box>{children}</Box>
      </Stack>
    </Grid>
  );
};
